import { render, staticRenderFns } from "./comp-share.vue?vue&type=template&id=0a720e52&scoped=true&lang=pug&"
import script from "./comp-share.vue?vue&type=script&lang=js&"
export * from "./comp-share.vue?vue&type=script&lang=js&"
import style0 from "./comp-share.vue?vue&type=style&index=0&id=0a720e52&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a720e52",
  null
  
)

/* custom blocks */
import block0 from "./comp-share.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports